// @flow

import axios from "axios";
import { localStorage } from "utils/storage";
import store from "store/configureStore";
import * as ActionTypes from "ducks/user/constants";
import { TRANSPORTS, BLOB_DATA, BODY_JSON, QUERY_PARAMS } from "./transports";

export const GET = "get";
export const PATCH = "patch";
export const POST = "post";
export const PUT = "put";
export const DELETE = "delete";
export const HEAD = "head";
export const ACCESS_TOKEN = "access_token";

type Config = any;

const http = axios.create();
http.interceptors.request.use((config: Config) => {
  if (localStorage.getItem(ACCESS_TOKEN)) config.headers.Authorization = `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`;

  const isBlob = config.data && Object.keys(config.data)
    .some((field: string) => config.data[field] instanceof Blob);

  if (isBlob) {
    return TRANSPORTS[BLOB_DATA](config);
  }

  switch (config.method) {
    case GET:
    case HEAD:
      return TRANSPORTS[QUERY_PARAMS](config);

    case POST:
    case PUT:
    case DELETE:
    case PATCH:
      return TRANSPORTS[BODY_JSON](config);
    default:
      break;
  }

  return config;
});

http.interceptors.response.use((response) => {
  return response;
}, (error) => {
  // error.response is undefined in case of POST and 401 response
  // only get a Network Error
  if (error.response && error.response.status === 401) {
    localStorage.removeItem(ACCESS_TOKEN);
    store.dispatch({ type: ActionTypes.USER_LOGOUT_REQUEST });
  }
  return Promise.reject(error.response);
});

export default http;



// WEBPACK FOOTER //
// ./src/utils/http/index.js